import React from 'react';

const ViewToggle = ({ view, setView }) => {
  return (
    <div className="flex w-full rounded-lg border border-gray-300 p-1 bg-white">
      <button
        className={`flex-1 px-2 sm:px-3 py-1 rounded-md text-xs sm:text-sm font-medium transition-colors duration-200 ease-in-out whitespace-nowrap ${
          view === 'details'
            ? 'bg-blue-500 text-white'
            : 'text-gray-700 hover:bg-gray-100'
        }`}
        onClick={() => setView('details')}
      >
        Home Details
      </button>
      <button
        className={`flex-1 px-2 sm:px-3 py-1 rounded-md text-xs sm:text-sm font-medium transition-colors duration-200 ease-in-out whitespace-nowrap ${
          view === 'calendar'
            ? 'bg-blue-500 text-white'
            : 'text-gray-700 hover:bg-gray-100'
        }`}
        onClick={() => setView('calendar')}
      >
        Calendar
      </button>
      <button
        className={`flex-1 px-2 sm:px-3 py-1 rounded-md text-xs sm:text-sm font-medium transition-colors duration-200 ease-in-out whitespace-nowrap ${
          view === 'reviews'
            ? 'bg-blue-500 text-white'
            : 'text-gray-700 hover:bg-gray-100'
        }`}
        onClick={() => setView('reviews')}
      >
        Guestbook
      </button>
      <button
        className={`flex-1 px-2 sm:px-3 py-1 rounded-md text-xs sm:text-sm font-medium transition-colors duration-200 ease-in-out whitespace-nowrap ${
          view === 'guestinfo'
            ? 'bg-blue-500 text-white'
            : 'text-gray-700 hover:bg-gray-100'
        }`}
        onClick={() => setView('guestinfo')}
      >
        Guest Info
      </button>
    </div>
  );
};

export default ViewToggle;